// extracted by mini-css-extract-plugin
module.exports = {"swap-seat-map-card":"swapSeatMapCard_swap-seat-map-card__2U08Z"};